import { Block } from '../types/shared/blocks';

export function removeBlockRef(block: Block) {
	return {
		...block,
		ref: null,
		...(block.landings && {
			landings: block.landings.map((landing) => ({ ...landing, ref: null })),
		}),
		...(block.stairs && {
			stairs: block.stairs.map((stair) => ({ ...stair, ref: null })),
		}),
		...(block.bumpouts && {
			bumpouts: block.bumpouts.map((bumpout) => ({ ...bumpout, ref: null })),
		}),
	};
}

function removeBlockRefs(blocks: Block[]) {
	return blocks.map(removeBlockRef);
}

export default removeBlockRefs;
